import angular from 'angular';

import commonModule from '../../common';
import stopMoveModal from './stopMoveModal.component';

export default angular.module('fp:customerportal:moveportal:modals',
        [
            commonModule.name
        ])
    .component('fpStopMoveModal', stopMoveModal);